import ConfirmationDialog from './ConfirmationDialog.component';

export * from './interfaces';
export default ConfirmationDialog;
